import React from 'react';

import { observer } from 'mobx-react';

import { OrderDetailsLayout } from '../../../components/checkout/OrderDetailsLayout/OrderDetailsLayout';
import { PriceInfo } from './PriceInfo/PriceInfo';
import { DetailsTable } from '../../../components/checkout/DetailsTable/DetailsTable';
import { challengeCheckoutStore } from '../../../stores/challengeCheckoutStore';

const OrderDetailsBlock = observer(() => {
  const { challengeCheckoutInfo } = challengeCheckoutStore;

  if (!challengeCheckoutInfo) {
    return null;
  }

  const { challenge, checkoutDetails, tax } = challengeCheckoutInfo;

  return (
    <OrderDetailsLayout>
      <PriceInfo />
      <DetailsTable
        targetName={challenge.challengeName}
        totalAmount={checkoutDetails.totalAmount}
        taxAmount={checkoutDetails.taxAmount}
        price={challenge.priceFinal}
        tax={tax}
      />
    </OrderDetailsLayout>
  );
});

export { OrderDetailsBlock };
